export const RecurrencePeriodEnum = {
    Never: 0,
    Daily: 1,
    Weekly: 2,
    Fortnightly: 3,
    Monthly: 4,
    Bimonthly: 5,
    Quarterly: 6,
    SixMonthly: 7,
    Yearly: 8
};
